module.exports = __webpack_public_path__ + "static/media/Dolores Kitchen Bookcases.467d813a.jpg";